import {
  BookingsQueryParams,
  WixOOISDKAdapter,
} from '@wix/bookings-adapter-ooi-wix-sdk';
import { SubmissionResponse } from '@wix/forms-ui/types';

export function getSessionValues(
  wixSdkAdapter: WixOOISDKAdapter,
  key: BookingsQueryParams,
) {
  const valueFromStorage: string = wixSdkAdapter.getFromSessionStorage(key);

  if (valueFromStorage) {
    return JSON.parse(valueFromStorage);
  }
}

export function setFieldsValuesInStorage(
  wixSdkAdapter: WixOOISDKAdapter,
  submissionResponse: SubmissionResponse,
) {
  const { submission } = submissionResponse;
  if (submission) {
    const fieldsForStorage = Object.keys(submission).reduce(
      (keyMap, fieldKey) => {
        return {
          ...keyMap,
          [fieldKey]: submission[fieldKey],
        };
      },
      {},
    );
    wixSdkAdapter.setToSessionStorage(
      BookingsQueryParams.FILLED_FIELDS,
      JSON.stringify(fieldsForStorage),
    );
  }
}
